var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-progress-bar"},[_c('div',{ref:"edProgress",staticClass:"progress"})])}
var staticRenderFns = []

export { render, staticRenderFns }